import { render, staticRenderFns } from "./HeaderBrand.vue?vue&type=template&id=b716db14&"
import script from "./HeaderBrand.vue?vue&type=script&lang=js&"
export * from "./HeaderBrand.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports